import React from "react";
import ReactDOM from "react-dom/client";
import AppRoutes from "./routes/Routes";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AppRoutes />
);
